module.exports = __webpack_public_path__ + "static/img/mashblock-nz.acc042b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mashblock-nz.svg
// module id = XZBD
// module chunks = 1